import { render, staticRenderFns } from "./UserGroupSearch.vue?vue&type=template&id=616cca32"
import script from "./UserGroupSearch.vue?vue&type=script&lang=js"
export * from "./UserGroupSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports